var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticStyle:{"margin":"0 0 5px 20px"}},[_vm._v(_vm._s(_vm.$t('table.dynamicTips1')))]),_c('fixed-thead'),_c('div',{staticStyle:{"margin":"30px 0 5px 20px"}},[_vm._v(_vm._s(_vm.$t('table.dynamicTips2')))]),_c('unfixed-thead')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }